import { COLORS, Row } from '@cuemath/comps';
import { Text } from '@cuemath/web-comps';

import React from 'react';
import styled from 'styled-components';
import CloseIcon from 'img/black-cross-icon.svg';

const Root = styled.div`
  border: 1px solid ${COLORS.GHOST};
  border-radius: 8px;
  padding: 16px 12px;
  margin-top: 16px;
`;

const CloseButton = styled.img`
  cursor: pointer;
`;

export default function ClosableBox({ title, children, onClose }) {
  return (
    <Root>
      <Row justifyContent="space-between" alignItems="center">
        <Text variant="eyebrow2">{title}</Text>
        <CloseButton
          onClick={onClose}
          src={CloseIcon}
          width="24"
          height="24"
          alt="close"
        />
      </Row>
      {children}
    </Root>
  );
}
